import axios from 'axios'
import wcs from './index'

export class WcsGetSupport {
  static getSupportSearchResults = async (
    endPoint: string,
    searchTerm: string,
    pageNumber: number,
    catalogId: number,
    storeId: number,
    langId: number
  ) => {
    const params = {
      catalogId,
      storeId,
      langId,
      pageSize: 12,
      clientSide: true,
      searchType: 1000,
      viewMode: 'Client',
      showResultsPage: true,
      beginIndex: 0,
      sType: 'SimpleSearch',
      newpage: true,
      searchTerm: searchTerm,
      facetCall: true,
      pageNumber: pageNumber,
      productSearch: false,
      contentSearch: true,
      getSupportSearch: true,
      pageSizeContent: 8,
      pageNumberContent: pageNumber,
    }
    const response = await axios.get(endPoint, { params: params })
    if (response.data.contentdata) {
      response.data.contentdata = response.data.contentdata.map(
        (contentData: {
          longDescription?: string
          shortDescription?: string
          name: string
          url: string
        }) => {
          return {
            title: contentData.name,
            link: contentData.url,
            description: contentData.shortDescription || contentData.longDescription,
            url: contentData.url,
          }
        }
      )
      return response.data
    } else if (response.request.responseURL) {
      window.location = response.request.responseURL
    }
  }

  static getSearchSuggestion = async () => {
    const response = await axios.get(wcs.getEndPoint('getSupportSearch'))

    const escapedSuggestions =
      response.data.MarketingSpotData[0].baseMarketingSpotActivityData[0]
        .marketingContentDescription[0].marketingText
    const suggestions = JSON.parse(escapedSuggestions)
    return suggestions.questions
  }

  static submitFeedback = async (params: any) => {
    const endpoint = wcs.getEndPoint('feedbackSubmit')
    const response = await axios.post(endpoint, params)
    if (response.status === 201) {
      return {
        success: true,
      }
    } else {
      return {
        serverError: true,
        success: false,
      }
    }
  }
}
